import { escapeHtml } from '../utils/html'
import { footerTemplate } from './layoutTemplates'

export function overlayBackButtonTemplate(): string {
	return `
        <button
            id="overlay-nav-back-btn"
            class="btn back icon secondary"
        >
            <svg><use href="#symbols-arrow-back"></use></svg>
        </button>
    `
}

export function overlayExternalLinkTemplate(
	linkUrl: string,
	linkLabel: string,
): string {
	return `
        <a
            href="${escapeHtml(linkUrl)}"
            target="_blank"
            rel="noopener"
            class="btn noFrame link"
        >
            <svg><use href="#symbols-external-link"></use></svg>
            ${escapeHtml(linkLabel)}
        </a>
    `
}

export function overlayContentTemplate(
	content: string,
	linkHtml: string,
	backLabel: string,
): string {
	return `
        <div class="overlay-header-actions">
            <button class="btn noFrame back">
                <svg><use href="#symbols-arrow-back"></use></svg>
                ${backLabel}
            </button>
            ${linkHtml}
        </div>
        <div class="overlay-inner-content overlay-fade">${content}</div>
        ${footerTemplate()}
    `
}
